import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import Loader from '../../Loader'

function TotalLeaveView({ totalLeave }) {
  const data = [
    { label: 'Leave Type', data: totalLeave.leaveType ? totalLeave.leaveType.name : "" },
    { label: 'Leave Allocated', data: totalLeave.leaveAllocated },
    { label: 'Rank', data: totalLeave.rank }
  ]
  return (
    <Grid container>
      {totalLeave ? (
        <Grid item lg={12} container spacing={3}>
          {data.map((item, index) => (
            <Grid item lg={4} key={index}>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
                <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Loader />
      )}
    </Grid>
  )
}

export default TotalLeaveView
